import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { DEFAULT_CURRENCY_CODE, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { translationChunksConfig } from '@spartacus/assets';
import { ConfigModule, HttpErrorHandler, provideConfig } from '@spartacus/core';
import {
  AppRoutingModule,
  ProductListComponentService,
} from '@spartacus/storefront';
import { LayoutConfigModule } from '../../src/features/layout/layout.module';
import { AccountOverviewModule } from './account-overview/account-overview.module';
import { AppLazyModule } from './app-lazy.module';
import { CustomAddToCartModule } from './custom-add-to-cart/custom-add-to-cart.module';
import { CustomBannerModule } from './custom-banner/custom-banner.module';
import { CustomLogoutModule } from './custom-logout/custom-logout.module';
import { CustomMakeAPaymentModule } from './custom-make-a-payment/custom-make-a-payment.module';
import { CustomProdListService } from './custom-prod-pg/custom-prod-list.service';
import { CustomUserRegistrationRootModule } from './custom-user-registration/custom-user-registration-root.module';
import { EmptyCms } from './empty-cms/empty-cms.component';
import { FaqModule } from './faq/faq.module';
import { ForbiddenHandler } from './forbidden-handler.service';
import { HomeScreenModule } from './home-screen/home-screen/home-screen.module';
import { SearchBoxModule } from './search-box/search-box.module';
import { AddCardModule } from './shared/modules/add-card/add-card.module';
import { FileUploadModule } from './shared/modules/file-upload/file-upload.module';
import { LocationStripModule } from './shared/modules/location-strip/location-strip.module';
import { SelectWhsPopupModule } from './shared/modules/switch-whs-popup/select-whs-popup.module';
import { LocalCurrencyPipe } from './shared/pipes/localcurency';
import { MainPipeModule, SafeHtmlPipe } from './shared/pipes/mainpipe.module';
import { StatementsPipeModule } from './shared/pipes/statementspipe.module';
import { SanofiCsAgentAuthService } from './spartacus/features/asm/root/services/sanofi-csagent-auth.service';
import { SpartacusModule } from './spartacus/spartacus.module';
import { ToolsAndResourcesModule } from './tools-and-resources/tools-and-resources.module';
import { UnauthorizedHandler } from './unauthorized-handler-service';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    SpartacusModule,
    LayoutConfigModule,
    CustomUserRegistrationRootModule,
    NgSelectModule,
    FormsModule,
    HomeScreenModule,
    AddCardModule,
    SearchBoxModule,
    LocationStripModule,
    SearchBoxModule,
    FaqModule,
    ToolsAndResourcesModule,
    MainPipeModule,
    StatementsPipeModule,
    FileUploadModule,
    SelectWhsPopupModule,
    CustomBannerModule,
    AppLazyModule,
    BrowserAnimationsModule,
    CustomLogoutModule,
    CustomAddToCartModule,
    AccountOverviewModule,
    CustomMakeAPaymentModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AssistedServiceComponent: {
          component: EmptyCms,
        },
        AccountOverviewReportsComponent: {
          component: EmptyCms,
        },
        AccountOverviewOrdersComponent: {
          component: EmptyCms,
        },
        ProductMonographCarouselComponent: {
          component: EmptyCms,
        },
      },
    }),
  ],
  providers: [
    {
      provide: ProductListComponentService,
      useClass: CustomProdListService,
    },
    {
      provide: HttpErrorHandler,
      useExisting: ForbiddenHandler,
      multi: true,
    },
    {
      provide: CsAgentAuthService,
      useClass: SanofiCsAgentAuthService,
    },
    {
      provide: HttpErrorHandler,
      useExisting: UnauthorizedHandler,
      multi: true,
    },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: 'DZD',
    },
    DatePipe,
    CurrencyPipe,
    SafeHtmlPipe,
    LocalCurrencyPipe,
    NgbActiveModal,
    provideConfig({
      i18n: {
        backend: {
          loadPath: '/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class AppModule {}
